import type { TextProps } from 'react-native'
import { cn } from '~/lib/utils.ts'
import { Text } from '../ui/text'

export const Heading1 = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-light text-2xl/relaxed', className)} {...props}>
      {children}
    </Text>
  )
}

export const Heading2 = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-semibold text-xl/relaxed', className)} {...props}>
      {children}
    </Text>
  )
}

export const Heading3 = ({ children, className, ...props }: TextProps) => {
  return (
    <Text className={cn('font-semibold text-lg/relaxed', className)} {...props}>
      {children}
    </Text>
  )
}
